var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChannel(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 48,
    viewBox: "0 0 48 48",
    width: 48,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "var(--secondary-green-200)",
    height: 48,
    rx: 4,
    width: 48
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#fffffe"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.47 24.904h-2.122c.216.592.334 1.23.334 1.897v8.017c0 .277-.048.544-.136.792h3.507a2.378 2.378 0 002.376-2.376v-4.37a3.964 3.964 0 00-3.96-3.96zM15.746 26.8c0-.665.118-1.304.335-1.896h-2.122A3.964 3.964 0 0010 28.864v4.37a2.378 2.378 0 002.376 2.376h3.507a2.365 2.365 0 01-.137-.792zM26.139 22.841h-4.85a3.964 3.964 0 00-3.959 3.96v8.017c0 .437.355.792.792.792h11.185a.792.792 0 00.791-.792V26.8a3.964 3.964 0 00-3.959-3.96zM23.714 11.76a4.767 4.767 0 00-4.761 4.761 4.765 4.765 0 004.761 4.762 4.765 4.765 0 004.762-4.762 4.767 4.767 0 00-4.762-4.762zM15.353 16.198a3.565 3.565 0 00-3.561 3.56 3.565 3.565 0 004.964 3.273 3.583 3.583 0 001.74-1.6c.266-.498.418-1.068.418-1.672a3.565 3.565 0 00-3.561-3.561zM32.076 16.198a3.565 3.565 0 00-3.561 3.56c0 .605.151 1.175.418 1.674.38.71.995 1.279 1.74 1.6a3.565 3.565 0 004.964-3.273 3.565 3.565 0 00-3.561-3.561z"
  })))));
}
export default SvgChannel;